import { COUNTRY_CONFIGURATION } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { ICountryConfigRepository } from "../domain/repositories/ICountryConfigRepository";
import { CountryConfigFormRequestEntity } from "../domain/entities/CountryConfigFormRequestEntity";
import { injectable } from "tsyringe";
import { CountryConfigListRequestModel } from "./model/CountryConfigListRequestModel";
import { CountryConfigResponseModel } from "./model/CountryConfigResponseModel";

@injectable()
export class CountryConfigImpl implements ICountryConfigRepository {
  async getList(
    params: CountryConfigListRequestModel,
  ): Promise<ListBaseApiResponseModel<CountryConfigResponseModel>> {
    return await client?.get(COUNTRY_CONFIGURATION?.LIST, params);
  }

  async getDetail(params: {
    id: string;
  }): Promise<BaseApiResponseModel<CountryConfigResponseModel>> {
    return await client?.get(COUNTRY_CONFIGURATION?.DETAIL, params);
  }

  async create(
    body: CountryConfigFormRequestEntity,
  ): Promise<BaseApiResponseModel<CountryConfigResponseModel>> {
    const formData = this.buildFormData(body);
    return await client?.post(COUNTRY_CONFIGURATION?.CREATE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async update(
    body: CountryConfigFormRequestEntity,
  ): Promise<BaseApiResponseModel<CountryConfigResponseModel>> {
    const formData = this.buildFormData(body);
    if (body?.isUploadFile) {
      formData.append("isUploadFile", body.isUploadFile);
    }
    return await client?.put(
      `${COUNTRY_CONFIGURATION?.UPDATE}?id=${body.id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
  }

  async delete(params: {
    id: string;
  }): Promise<BaseApiResponseModel<CountryConfigResponseModel>> {
    return await client?.delete(COUNTRY_CONFIGURATION?.DELETE, params);
  }

  private buildFormData(body: CountryConfigFormRequestEntity): FormData {
    const formData = new FormData();
    if (body.name) formData.append("name", body.name);
    if (body.code) formData.append("code", body.code);
    if (body.capital) formData.append("capital", body.capital);
    if (body.region) formData.append("region", body.region);

    if (body.ensignFile) {
      formData.append("file", body.ensignFile, `Ensign_${body.ensignFile.name}`);
    }
    if (body.coverFile) {
      formData.append("file", body.coverFile, `Cover_${body.coverFile.name}`);
    }

    return formData;
  }
}
